import { lazy } from 'react';

const EmployeeUpload = lazy(() => import('./EmployeeUpload'));

export default EmployeeUpload;
